import { render } from "./smsHistory.vue?vue&type=template&id=2bc5dfde&scoped=true"
import script from "./smsHistory.vue?vue&type=script&lang=js"
export * from "./smsHistory.vue?vue&type=script&lang=js"

import "./smsHistory.vue?vue&type=style&index=0&id=2bc5dfde&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc5dfde"]])

export default __exports__